// Video extension (admin side): the product's videos, one of them the main one (its trailer). Every catalog
// product may have them (no profile switches it on): the tab reads and writes through the shared catalog
// editor (../shared/catalog-editor.jsx). The id stays "trailer": the review marks and the settings name it.
import { PlayCircleIcon } from "@heroicons/react/24/outline"
import TrailerTab from "./TrailerTab"
import { CatalogEditorProvider, catalogSection, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { reviewBadge } from "../shared/review-marks"

export const StoreProductExtension = {
  id: "trailer",
  label: "Video",
  description: "The product's videos (YouTube), one of them the main one: its trailer",
  // every product may have videos: the type's list of extensions does not scope this tab
  allProducts: true,
  section: {
    component: catalogSection(TrailerTab),
    label: "Video",
    icon: PlayCircleIcon,
    badge: reviewBadge("trailer"),
    order: 400,
    visible: (context) => !!context?.catalogProduct,
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
